module.exports = __webpack_public_path__ + "img/files-alt.b3e178d0.svg";